import { Location } from './location';
export class ProductLocation extends Location {
}
//# sourceMappingURL=product-location.js.map